import HTTP from '@api';

import { generateXHRError } from '@helpers';

export default {
  namespaced: true,
  state: {
    job: {},
    jobs: [],
    jobProxyTestResult: {},
  },
  mutations: {
    setJob(state, payload) {
      state.job = payload;
    },
    setJobs(state, payload) {
      state.jobs = payload;
    },
    setJobProxyTestResult(state, payload) {
      state.jobProxyTestResult = payload;
    },
  },
  actions: {
    async getJob({ commit, rootState: { locations } }, { suffix = locations.suffix, id }) {
      commit('setJob', {});
      try {
        const { data } = await HTTP.get(`${suffix}/job/${id}`);
        commit('setJob', data || {});
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async getJobs({ commit, rootState: { locations } }, {
      suffix = locations.suffix, substate = null,
      outerId = null, basketId = null, vendor = null,
      state = null, pageNum = 1, pageSize = 10,
    }) {
      try {
        const { data } = await HTTP.get(`${suffix}/job`, {
          params: {
            suffix, substate, outerId, basketId, vendor, state, pageNum, pageSize,
          },
        });
        commit('setJobs', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async syncJob({ rootState: { locations } }, { suffix = locations.suffix, id }) {
      try {
        await HTTP.post(`${suffix}/job/${id}/sync`);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async syncAllJobs({ rootState: { locations } }, { suffix = locations.suffix, vendor, days }) {
      try {
        await HTTP.post(`${suffix}/job/${vendor}/syncall`, { days });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async syncJobsByIds({ rootState: { locations } }, { suffix = locations.suffix, vendor, ids }) {
      try {
        await HTTP.post(`${suffix}/job/${vendor}/syncids`, { ids });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async runJobProxyTest({ commit, rootState: { locations } }, { suffix = locations.suffix, id }) {
      commit('setJobProxyTestResult', {});
      try {
        const { data } = await HTTP.get(`${suffix}/job/${id}/proxytest`);
        commit('setJobProxyTestResult', data || {});
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },
  },
};
